import { Ban, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/components/ui/alert-dialog';

/**
 * AlertDialog de confirmation pour révoquer une invitation
 */
export default function AlertDialogRevokeInvitation({ open, onOpenChange, invitation, onConfirm, isLoading }) {
    const { t } = useTranslation();
    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle className="flex items-center gap-2">
                        <Ban className="h-5 w-5 text-warning" />
                        {t('procedures:revoquerLInvitation')}
                    </AlertDialogTitle>
                    <AlertDialogDescription>
                        {t('procedures:voulezVousVraimentRevoquerLInvitationEnvoyeeA')}{' '}
                        <span className="font-medium text-foreground">{invitation?.email}</span> ?
                        <br />
                        <br />
                        {t('procedures:lInviteNePourraPlusAccederAuFormulaire')}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel disabled={isLoading}>{t('procedures:annuler')}</AlertDialogCancel>
                    <AlertDialogAction
                        onClick={onConfirm}
                        disabled={isLoading}
                        className="bg-warning hover:bg-warning/90 text-warning-foreground"
                    >
                        {isLoading ? (
                            <>
                                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                                {t('procedures:revocation')}
                            </>
                        ) : (
                            t('procedures:revoquer')
                        )}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
